export default __webpack_public_path__ + "static/media/AW LOGO.1ad103e0.JPG";